import React from 'react'
import { getFixedPercentage } from '../../../../../../../helpers'

const TopCategory = ({
  category,
  color,
  containerClassName = '',
  className = '',
  titleClassName = '',
  titleWrapperClassName = '',
}) => {
  return (
    <div className={`borderViewLightPink rounded w-full pl-[10px] pt-[12px] ${containerClassName}`}>
      <div className={`flex items-start h-full textary_div ${className}`}>
        <div
          aria-hidden
          style={{ backgroundColor: color }}
          className="flex w-[20px] h-[20px] rounded-[6px] border-[1px]"
        />

        <div className={`flex-1 text-sm ml-[6px] ${titleWrapperClassName}`}>
          <h6
            style={{ color }}
            className={`font-bold text-[10px] min-h-[20px] flex items-center ${titleClassName}`}
          >
            {category.category} (
            {category.booking_percentage ? getFixedPercentage(category.booking_percentage) : 0}%)
          </h6>

          <span className="text-[#F67443] text-xs not-italic">
            {category.total_bookings} Classes
          </span>
        </div>
      </div>
    </div>
  )
}

export default TopCategory
